import { PopperContent } from '@/components/poppers/PopperContent';
import { ContextualHelpTooltip } from '@/modules/content/components/ContextualHelpTooltip';
import { COLORS } from '@/styles/tokens/colors';

interface SuggestionNotesHelpProps {
  notes?: string | null;
}

export function SuggestionNotesHelp({ notes }: SuggestionNotesHelpProps) {
  if (!notes) {
    return null;
  }

  return (
    <ContextualHelpTooltip
      // inline-flex + middle alignment lets the icon flow with the name text;
      // the 14px icon stays within the title-xs 16px line so it doesn't add
      // extra spacing between wrapped lines.
      sx={{ display: 'inline-flex', verticalAlign: 'middle' }}
      iconProps={{ color: COLORS.TEXT.SECONDARY, size: 14 }}
    >
      <PopperContent body={notes} />
    </ContextualHelpTooltip>
  );
}
